import React, { PureComponent } from "react";
import {GridContainer, GridRow, GridColumn, Button} from "arv-reactcomponents";
import { MyBag, ROUTE_PATHS } from "npmlinks-constants";
import Anchor from "../Anchor";

const isMyBagOfferingEnabled = process.env.REACT_APP_isMyBagOfferingEnabled;
class MybagOfferingBlock extends PureComponent {
  render() {

    if (isMyBagOfferingEnabled){
      return (
        <div className="nw-mybagofferingblock-wrapper nw-desktop-only">
          <GridContainer className="nw-mybagofferingblock-container">
            <GridRow className="nwc-grid-row">
              <GridColumn className="nwc-grid-col nwc-grid-col-sm-8 nw-mybagofferingblock-leftcol">
                <GridRow className="nwc-grid-row">
                  <GridColumn className="nwc-grid-col-sm-6" >
                    <div className="nw-mybagofferingblock-innerblocks">
                      <div className="nw-mybagofferingblock-lefttpart">
                        <div className="nw-mybagofferingblock-lefttpartspan">
                           <i className="icomoon-delivery-truck" />
                        </div>
                        <span className="nw-mybagofferingblock-title">{MyBag.MYBAGOFFERINGBLOCK.DELIVERY_TITLE}</span>
                      </div>
                      <div className="nw-mybagofferingblock-rightpart">
                        <span>{MyBag.MYBAGOFFERINGBLOCK.DELIVERY_LABEL}</span>
                      </div>
                    </div>
                  </GridColumn>
                  <GridColumn className="nwc-grid-col-sm-6 nw-mybagofferingblock-secondcol">
                    <div className="nw-mybagofferingblock-innerblocks">
                      <div className="nw-mybagofferingblock-lefttpart">
                        <div className="nw-mybagofferingblock-lefttpartspan">
                           <i className="icomoon-return" />
                        </div>
                        <span className="nw-mybagofferingblock-title">{MyBag.MYBAGOFFERINGBLOCK.RETURN_TITLE}</span>
                      </div>
                      <div className="nw-mybagofferingblock-rightpart">
                        <span>{MyBag.MYBAGOFFERINGBLOCK.RETURN_LABEL}</span>
                      </div>
                    </div>
                  </GridColumn>
                </GridRow>
              </GridColumn>
              <GridColumn className="nwc-grid-col nwc-grid-col-sm-4">
                  <div className="nw-mybagofferingblock-innerblocks">
                    <div className="nw-mybagofferingblock-lefttpart">
                      <div className="nw-mybagofferingblock-title">{MyBag.MYBAGOFFERINGBLOCK.SAVEDITEM_TITLE}</div>
                    </div>
                    <div className="nw-mybagofferingblock-rightpart">
                      <span>{MyBag.MYBAGOFFERINGBLOCK.SAVEDITEM_LABEL}</span>
                      <div className="nw-mybagofferingblock-favoritebutton">
                        <Anchor.component
                          target="_self"
                          to={ROUTE_PATHS.URL}
                          href={ROUTE_PATHS.URL}
                          className="nwc-btn nwc-btn-normal nw-mybagofferingblock-link"
                        >
                          {MyBag.MYBAGOFFERINGBLOCK.SAVED_BUTTONTEXT}
                        </Anchor.component>
                      </div>
                    </div>
                  </div>
              </GridColumn>
            </GridRow>
          </GridContainer>
        </div>
      );
    }
    return null;
  }
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: MybagOfferingBlock,
  component: MybagOfferingBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MybagOfferingBlock/index.js